import InAWordConstants from "../../../../../../platform_common_constants/in_a_word_constants.json";

export { InAWordConstants };
